import { app } from "../config/firebaseConfig";
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged,sendPasswordResetEmail  } from 'firebase/auth';

import { getFirestore, collection, doc, setDoc, getDocs, query, orderBy, where, DocumentData, deleteDoc } from 'firebase/firestore';


const auth = getAuth(app);
const db = getFirestore(app);
const currentUser = auth.currentUser;

export const loginUser = async (email: string, password: string) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    console.log("User logged in successfully:", userCredential.user);
    // You might want to redirect the user to a dashboard or home page here
     return userCredential;
  } catch (firebaseError:any) {
    console.error("Error logging in:", firebaseError.message);
    throw firebaseError.code; 
  }
};

export const logoutUser = async () => {
  try {
    await signOut(auth);
    console.log("User signed out successfully.");
    // You might want to redirect the user to a login page here
    // e.g., history.push('/login'); if using React Router
  } catch (error:any) {
    console.error("Error signing out:", error.message);
  }
};

export const subscribeToAuthChanges = (callback:any) => {
  return onAuthStateChanged(auth, callback);
};

export const  getCurrentUser = () => {
   if (currentUser) {
     const username = currentUser.email;
     console.log("Current user's display name:", username);
     // You can then return or use 'username' as needed
     return username;
    } else {
      console.log("No user is currently signed in.");
     return null; // Or handle as appropriate for your application
    }
};

 export  const handleForgotPassword = async (email: string) => {
  try {
      await sendPasswordResetEmail(auth, email);
       alert("Password reset email sent! Please check your inbox.");
    } catch (error: any) {
       console.error("Error sending password reset email:", error.message);
       alert(`Failed to send password reset email: ${error.message}`);
    }
  };

// Define the MyData interface according to your data structure
interface MyData {
  // Example fields, replace with actual fields as needed
  id?: string;
  uid:string
  firstName: string;
  lastName: string;
  fullName: string;
  grade:string
  hourlyRate: string;
  major: string;
  email: string;
  phoneNumber: string;
  discount:number;
}

interface StudentHoursFormDetails {
  studentId?: string;
  firstName: string;
  lastName: string;
  fullName: string;
  hourlyRate: string ;
  email?: string;
  grade: string;
  major: string;
  hours:number;
  phoneNumber: string;
  selectedDate: Date | null;
  discount:number;
}

// Add student data to Firestore
  export const addStudentData = async (data: MyData) => {
  try {
    console.log("Adding student data:", data);
    // Add a new document with a generated id.
    //const docRef = await addDoc(collection(db, "students"), {
    const docRef =  doc(collection(db, "students"));
    await setDoc(docRef, {
      id: docRef.id,
      uid:data.uid,
      firstName: data.firstName,
      lastName: data.lastName,
      grade: data.grade,
      hourlyRate: data.hourlyRate,
      major: data.major,
      email: data.email,
      phoneNumber:data.phoneNumber,
      fullName: `${data.firstName} ${data.lastName}`, 
      creationDate: new Date(),
      discount:data.discount,
    });
    console.log("Document written with ID: ", docRef.id);
    return docRef.id; 
  } catch (e) {
    console.error("Error adding document: ", e);
    throw e;
  }
};

//Add the daily hours data to Firestore
export const addDailyHoursData = async (hoursForm:StudentHoursFormDetails) => {
  try {
    const docRef = doc(collection(db,  "dailyHours"));
    await setDoc(docRef, {
      studentId: hoursForm.studentId,
      date: hoursForm.selectedDate ? hoursForm.selectedDate : new Date(),
      firstName: hoursForm.firstName,
      lastName: hoursForm.lastName,
      fullName: hoursForm.fullName,
      hourlyRate: hoursForm.hourlyRate,
      hours: hoursForm.hours,
      email: hoursForm.email,
      grade: hoursForm.grade,
      major: hoursForm.major,
      phoneNumber:hoursForm.phoneNumber,
      discount:hoursForm.discount,
      creationDate: new Date()
    });
    console.log("Daily hours document written with ID: ", docRef.id);
    return docRef.id;
  } catch (e) {
    console.error("Error adding daily hours document: ", e);
    throw e;
  }
};

// Fetch student data from Firestore
export const fetchStudentData = async () => {
  try {
    const studentsQuery = query(collection(db, "students"), orderBy("fullName", "asc"),
            orderBy('__name__', 'asc') // Then order by document ID (path) in ascending order
    );
    const querySnapshot = await getDocs(studentsQuery);
    const students = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }
  ));
    return students;
  } catch (error) {
    console.error("Error fetching student data:", error);
    throw error;
  }
};

export const getUniqueFullNames = async (table:string) => {
  try {
    const usersCollection = collection(db, table);
    const querySnapshot = await getDocs(usersCollection);

    const names = new Set<string>();
    querySnapshot.forEach(doc => {
      const data = doc.data();
      const firstName = data.firstName;
      const lastName = data.lastName;
      if (firstName && lastName) {
        names.add(`${firstName} ${lastName}`);
      }
    });
console.log('Unique full names:', names);
    return Array.from(names).sort();
  } catch (e) {
    console.error("Error fetching unique names: ", e);
    return [];
  }
};

export const getUsersByFullName = async (
  fullName: string
): Promise<MyData[]> => {
  const usersRef = collection(db, 'students');
  const q = query(
    usersRef,
    where('fullName', '==', fullName)
  );

  const querySnapshot = await getDocs(q);
  const users: MyData[] = [];
  querySnapshot.forEach((doc: DocumentData) => {
    users.push({
      id: doc.id,
      ...doc.data(),
    } as MyData);
  });
console.log('Fetched users by full name:', users);
  return users;
};

// Update student data in Firestore
export const updateStudentData = async (id: string, data: Partial<MyData>) => {
  try {
    const docRef = doc(db, "students", id);   
    await setDoc(docRef, data);
    console.log("Document updated with ID: ", id);
  } catch (e) {
    console.error("Error updating document: ", e);
    throw e;
  }
};

//delete the Student data based on document Id
export const deleteRow = async (collectionName: string, documentId: string) => {
  try {
    await deleteDoc(doc(db, collectionName, documentId));
    console.log("Document successfully deleted!");
    // You might want to update your local state or re-fetch data after deletion
  } catch (error) {
    console.error("Error removing document: ", error);
  }
};

//get the daily hours data based on student full name and month/year
export const getDailyHoursData = async (fullName: string, month: number, year: number) => {
  console.log(new Date(year, month - 1, 1));
  console.log(new Date(year, month, 1));
  try { 
    const hoursRef = collection(db, 'dailyHours');
    const q = query(
      hoursRef,
      where('fullName', '==', fullName),
      where('date', '>=', new Date(year, month - 1, 1)),
      where('date', '<', new Date(year, month, 1))
    );
    const querySnapshot = await getDocs(q);
    const hoursData: any[] = [];
    querySnapshot.forEach((doc: DocumentData) => {
      hoursData.push({ id: doc.id, ...doc.data() });
    });
    console.log("hoursData"+hoursData);
    return hoursData;
  } catch (error) {
    console.error("Error fetching daily hours data:", error);
    throw error;
  }
}; 


const dataService = {
    signInWithEmailAndPassword: loginUser,
    signOut: logoutUser,
    currentUser: getCurrentUser,
    forgotPassword : handleForgotPassword,
    addStudentData : addStudentData,
    fetchStudentData : fetchStudentData,
    updateStudentData : updateStudentData,
    getUniqueFullNames : getUniqueFullNames,
    getUsersByFullName : getUsersByFullName,
    addDailyHoursData : addDailyHoursData,
    getDailyHoursData : getDailyHoursData,
    deleteRow: deleteRow
};

export default dataService;



